import { render, staticRenderFns } from "./BusinessPartnerResponsibleForm.vue?vue&type=template&id=3095e6cc&"
import script from "./BusinessPartnerResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerResponsibleForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerResponsibleForm.vue?vue&type=style&index=0&id=3095e6cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports